import { EntryType, EntryTypeGroup } from '../types';

export const TAGGING_TOOL_ENTRY_FIELDS_TO_PERSIST = [
  'id',
  'title',
  'description',
  'type',
  'editUrl',
] as const;

export type TaggingToolEntryField = typeof TAGGING_TOOL_ENTRY_FIELDS_TO_PERSIST[number];

export const ENTRY_TYPES_DISPLAY_NAMES: Record<EntryType, string> = {
  video: 'Video',
  meme: 'Meme',
  category: 'Category',
  station: 'Station',
  channel: 'Channel',
  podcast: 'Podcast',
  profile: 'Profile',
  show: 'Show',
  article: 'Article',
  creator: 'Creator',
  format: 'Format',
  soundpiece: 'Soundpiece',
};

export const MANUAL_ASSETS_FIELDS_TO_PERSIST = ['id', 'entryId', 'type'];

export const MANUAL_AND_AUTO_ASSETS_FIELDS_TO_PERSIST = [
  'id',
  'entryId',
  'type',
  'position',
];

export const contentTypesByEntryTypeGroup: Record<
  EntryTypeGroup,
  EntryType[]
> = {
  'App Types': [
    'video',
    'meme',
    'soundpiece',
    'channel',
    'format',
    'show',
    'category',
  ],
  Videos: ['video'],
  Memes: ['meme'],
  Soundpieces: ['soundpiece'],
  Formate: ['format'],
  Show: ['show'],
  Kategorien: ['category'],
  Stations: ['station'],
  Artikel: ['article'],
  Creators: ['profile'],
  Channels: ['channel'],
  Podcasts: ['podcast'],
  'Channels & Podcasts': ['channel', 'podcast'],
  'Shows, Formate & Profile': ['show', 'format', 'profile'],
};
